import { Routes, Route } from 'react-router-dom'
import { Providers } from '@/components/Providers'
import { Layout } from '@/components/Layout'
import { HomePage } from '@/pages/HomePage'

function App() {
  return (
    <Providers>
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800">
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
          </Route>
        </Routes>
      </div>
    </Providers>
  )
}

export default App